const GERAL_TITLE = "Geral";
const ALERTAS_MONITORAMENTO_TITLE = "Alertas de monitoramento";
const BUSCAR_TERMOS_TITLE = "Buscar termos";
const ASSINATURAS_TITLE = "Assinaturas";
const METODOS_PAGAMENTO_TITLE = "Métodos de pagamento";
const RELATAR_ERRO_OU_DUVIDA_TITLE = "Relatar Erro ou Dúvida";
const AJUDA_TITLE = "Ajuda";
const NAVEGACAO_TITLE = "Navegação";
const SUPORTE_TITLE = "Suporte";
const SUPORTE_PAGAMENTOS_TITLE = "Pagamentos";

const ALERTA_MONITORAMENTO_CONTENT_CARD_1 = "Como cadastrar um alerta";
const ALERTA_MONITORAMENTO_CONTENT_CARD_2 = "Como deletar um alerta";
const ALERTA_MONITORAMENTO_CONTENT_CARD_3 = "Como editar um alerta";

const TERMOS_PROCESSOS_CONTENT_CARD_1 = "Como buscar um termo no diário";
const TERMOS_PROCESSOS_CONTENT_CARD_2 = "Como buscar um processo judiciário";
const TERMOS_PROCESSOS_CONTENT_CARD_3 = "Como filtrar minhas buscas";

const PAGAMENTOS_CONTENT_CARD_1 = "Como cadastrar um cartão de crédito";
const PAGAMENTOS_CONTENT_CARD_2 = "Como deletar cartão de crédito";
const PAGAMENTOS_CONTENT_CARD_3 = "Como cancelar pagamento recorrente";

const titleConstants = {
  GERAL_TITLE,
  ALERTAS_MONITORAMENTO_TITLE,
  BUSCAR_TERMOS_TITLE,
  ASSINATURAS_TITLE,
  METODOS_PAGAMENTO_TITLE,
  RELATAR_ERRO_OU_DUVIDA_TITLE,
  AJUDA_TITLE,
  NAVEGACAO_TITLE,
  SUPORTE_TITLE,
  SUPORTE_PAGAMENTOS_TITLE,
};

const contentConstants = {
  ALERTA_MONITORAMENTO_CONTENT_CARD_1,
  ALERTA_MONITORAMENTO_CONTENT_CARD_2,
  ALERTA_MONITORAMENTO_CONTENT_CARD_3,
  TERMOS_PROCESSOS_CONTENT_CARD_1,
  TERMOS_PROCESSOS_CONTENT_CARD_2,
  TERMOS_PROCESSOS_CONTENT_CARD_3,
  PAGAMENTOS_CONTENT_CARD_1,
  PAGAMENTOS_CONTENT_CARD_2,
  PAGAMENTOS_CONTENT_CARD_3,
};

export {titleConstants, contentConstants};
